import { Link } from "react-router-dom";
import { useShop } from "@/context/Shop";
import { useFetch } from "@/hooks/useFetch";
import { dateOnly } from "@/lib/format";

function Card({ title, children, to, cta, testid }) {
  return (
    <div className="bg-white border rounded-lg p-6 lg:p-7 flex flex-col" data-testid={testid}>
      <p className="eyebrow">{title}</p>
      <div className="mt-3 flex-1">{children}</div>
      {to && <Link to={to} className="text-[12px] uppercase tracking-[0.14em] link-lux mt-5 self-start" data-testid={`${testid}-cta`}>{cta}</Link>}
    </div>
  );
}

export default function AccountHome() {
  const { customer, wishlist } = useShop();
  const { data: addresses } = useFetch("/account/addresses");
  const { data: orders } = useFetch("/account/orders");
  const def = (addresses?.items || []).find((a) => a.is_default_shipping) || (addresses?.items || [])[0];
  return (
    <div className="grid sm:grid-cols-2 gap-5" data-testid="account-home">
      <Card title="Personal details" to="/account/profile" cta="Edit profile" testid="account-card-profile">
        <p className="font-display text-xl">{customer.first_name} {customer.last_name}</p>
        <p className="text-sm text-muted-foreground mt-1">{customer.email}</p>
        <p className="text-xs text-muted-foreground mt-3">Member since {dateOnly(customer.created_at)}</p>
      </Card>
      <Card title="Default shipping address" to="/account/addresses" cta={def ? "Manage addresses" : "Add an address"} testid="account-card-address">
        {def ? (
          <address className="not-italic text-sm leading-relaxed text-foreground/85">{def.first_name} {def.last_name}<br />{def.line1}{def.line2 ? <>, {def.line2}</> : null}<br />{def.postal_code} {def.city}<br />{def.country_code}</address>
        ) : <p className="text-sm text-muted-foreground">No address on file yet.</p>}
      </Card>
      <Card title="Orders" to="/account/orders" cta={orders?.items?.length ? "View orders" : "Discover the store"} testid="account-card-orders">
        {orders?.items?.length ? <p className="font-display text-2xl">{orders.items.length} order{orders.items.length === 1 ? "" : "s"}</p> : <p className="text-sm text-muted-foreground">Order history will appear here once checkout is live.</p>}
      </Card>
      <Card title="Wishlist" to="/wishlist" cta="View wishlist" testid="account-card-wishlist">
        <p className="font-display text-2xl">{wishlist.count} piece{wishlist.count === 1 ? "" : "s"}</p>
      </Card>
    </div>
  );
}
